// src/pages/WrongPage.jsx
import React from 'react';
import { Link } from 'react-router-dom';

const WrongPage = () => {
  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center bg-[var(--bg)] text-center px-6"
      style={{ fontFamily: 'var(--font-body)' }}
    >
      <div className="bg-white border border-[var(--mist)] shadow-sm rounded-3xl px-8 py-12 md:px-14 md:py-14 max-w-md w-full">
        <span
          className="block text-[var(--coral)] text-xs tracking-[0.2em] uppercase mb-4"
          style={{ fontFamily: 'var(--font-mono)' }}
        >
          Connection Error
        </span>

        {/* Flatline — the same signal motif as the hero, here reading as a dropped connection */}
        <svg
          className="w-full max-w-[220px] mx-auto mb-6"
          height="28"
          viewBox="0 0 220 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path
            d="M0 14 H80 L92 14 H128 L140 14 H220"
            stroke="#FF5A4D"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeDasharray="4 6"
          />
        </svg>

        <h1
          className="text-3xl md:text-4xl font-medium text-[var(--ink)] mb-3"
          style={{ fontFamily: 'var(--font-display)' }}
        >
          Oops! Login Failed
        </h1>
        <p className="text-[var(--ink)]/70 mb-1">Something is technically wrong.</p>
        <p className="text-[var(--ink)]/70 mb-8">
          Make sure you have a good internet connection and your computer's clock is up to date.
        </p>

        <Link
          to="/login"
          className="inline-block px-8 py-3 rounded-full bg-[var(--teal)] text-white font-medium
                     hover:bg-[var(--teal-deep)] transition-colors duration-200"
        >
          Try again
        </Link>
      </div>
    </div>
  );
};

export default WrongPage;
